"use client";
import { CTAListModuleOptionsType } from "@/types/ModuleOptionsType";
import {
  Grid,
  GridContent,
  GridItem,
  GridLoadMore,
} from "@aleksundshantu/aunds-utils-react/primitives/grid";
// import { fetchLogos, LogosCardElementType } from "./fetchLogos";
import { HeaderLogoType } from "@/types/PageType";

import buttonStyles from "../../components/Button/Button.module.scss";
import { Modul_CTA_Liste } from "@aleksundshantu/gp-types/acf-module";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { CTAListBox, CTAListElementType } from "./CTAListBox/CTAListBox";
import { fetchCTAListItems } from "@/getData/fetchCTAListItems";

export type CTAListModuleType = Modul_CTA_Liste;

interface CTAListProps {
  data: CTAListModuleType;
  CTAListOptions: CTAListModuleOptionsType;
  itemHeadingLevel: number;
}

export type CTAListDataType = {
  totalPosts: number;
  elements: HeaderLogoType[];
};

const CTAListModuleClient = ({
  data,
  CTAListOptions,
  itemHeadingLevel,
}: CTAListProps) => {
  const {
    text_align_class,
    toggle_cardbox,
    trenner_anzeigen,
    icon_align_class,
    flex_direction_class,
    row_direction_class,
    posts_per_page,
  } = data.layout;

  const globalShowBox = CTAListOptions?.box?.show_card_box ?? false;
  const showCardbox = globalShowBox ? toggle_cardbox : false;
  const { getIcon, getLabel, locale, defaultLocale } = useGlobalContext();

  const fallbackIconMap: Record<string, string> = {
    glossary: "fallbackGlossar",
    blog: "fallbackPosts",
    quotes: "fallbackQuotes",
    team: "fallbackTeam",
    events: "fallbackEvents",
    magazine: "fallbackMagazine",
  };

  const iconKeys = fallbackIconMap[data.cta_list.type];
  const fallbackIconUrl: { type: string; url: string } = iconKeys
    ? { type: data.cta_list.type, url: getIcon(iconKeys) }
    : { type: data.cta_list.type, url: "" };

  const { grid_options } = CTAListOptions ?? {
    show_overline_subline: "none",
    columns: { breakpoint: "tablet", number_of_cols: 12 },
    grid_options: { grid_navigation: "load_more" },
  };
  const manualItemsCount = Array.isArray(data.cta_list.elements)
    ? data.cta_list.elements.length
    : 0;
  const loadingItemsCount =
    data.cta_list.type === "manual" ? manualItemsCount : posts_per_page;

  const labels = {
    postsBtn: getLabel("cta_list_postsBtn") || "Posts",
    eventsBtn: getLabel("cta_list_eventsBtn") || "Events",
    quotesBtn: getLabel("cta_list_quotesBtn") || "Quotes",
    teamBtn: getLabel("cta_list_teamBtn") || "Team",
    magazineBtn: getLabel("cta_list_magazineBtn") || "Magazine",
    glossarBtn: getLabel("cta_list_glossarBtn") || "Glossar",
  };

  return (
    <Grid
      postsPerPage={
        grid_options?.grid_navigation === "show-all" ? 100 : posts_per_page
      }
      fetchItems={({ page, postsPerPage, offset }) =>
        fetchCTAListItems({
          page,
          postsPerPage,
          offset,
          locale,
          defaultLocale,
          module: data,
          labels,
        })
      }
      renderLoading={{ numberOfItemsWhileLoading: loadingItemsCount }}
    >
      {(items, loading) => {
        return (
          <>
            <GridContent gap="2rem">
              {items.map((el, i) => (
                <GridItem itemWidth={{ mobile: "100%" }} key={i}>
                  <CTAListBox
                    CTAListElement={el as CTAListElementType}
                    ctaListOptions={CTAListOptions}
                    show_cardbox={showCardbox}
                    show_divider={trenner_anzeigen}
                    heading_level={itemHeadingLevel}
                    layoutOptions={{
                      icon_align_class,
                      flex_direction_class,
                      row_direction_class,
                      text_align_class,
                    }}
                    skeleton={loading}
                    fallbackIconUrl={fallbackIconUrl}
                    extraClass={`${text_align_class} ${icon_align_class}`}
                  />
                </GridItem>
              ))}
            </GridContent>
            {grid_options?.grid_navigation !== "show-all" && (
              <GridLoadMore
                grid_navigation={grid_options?.grid_navigation}
                buttonStyles={buttonStyles}
                iconPosition="left"
              />
            )}
          </>
        );
      }}
    </Grid>
  );
};

export default CTAListModuleClient;
